import wixWindow from 'wix-window';

$w.onReady(function () {
	
if(wixWindow.formFactor === "Mobile"){

$w("#mobilefooter").show();

}
});


export function Logo_click(event) {
wixWindow.trackEvent("CustomEvent", {
    "event": "Logo Click",
    "eventCategory": "Back to DoneDeal",
    "eventAction": "Logo Click",
    "eventLabel": "User returned to DoneDeal"
  } );
}